<template>
    <rkm-area
        no-margin-top
        title="Outros exames"
    >
        <rkm-row>
            <rkm-col cols="12">
                <rkm-list
                    :items="item.objetivo.resultadosExames"
                    hide-filters
                    hide-pagination
                >
                    <template v-slot="{item}">
                        <template v-if="getExamesEco().includes(item.exame.codigo)">
                            <rkm-row>
                                <rkm-col cols="4">
                                    <Item
                                        :get-value="() => `${formatProcedimento(item.exame.codigo)} - ${item.exame.nome}`"
                                        label="Exame"
                                    />
                                </rkm-col>

                                <rkm-col cols="3">
                                    <Item
                                        :get-value="() => item.idadeGestacionalSemanasEco"
                                        label="Idade gestacional em semanas eco"
                                    />
                                </rkm-col>

                                <rkm-col cols="3">
                                    <Item
                                        :get-value="() => item.idadeGestacionalDiasEco"
                                        label="Idade gestacional em dias eco"
                                    />
                                </rkm-col>

                                <rkm-col cols="2">
                                    <Item
                                        :get-value="() => item.dppEco"
                                        label="DPP eco"
                                    />
                                </rkm-col>
                            </rkm-row>

                            <rkm-row>
                                <rkm-col cols="4">
                                    <Item
                                        :get-value="() => item.solicitadoEm"
                                        label="Data da solicitação"
                                    />
                                </rkm-col>

                                <rkm-col cols="4">
                                    <Item
                                        :get-value="() => item.realizadoEm"
                                        label="Data da realização"
                                    />
                                </rkm-col>

                                <rkm-col cols="4">
                                    <Item
                                        :get-value="() => item.resultadoEm"
                                        label="Data do resultado"
                                    />
                                </rkm-col>
                            </rkm-row>
                        </template>

                        <rkm-row v-else>
                            <rkm-col cols="6">
                                <Item
                                    :get-value="() => `${formatProcedimento(item.exame.codigo)} - ${item.exame.nome}`"
                                    label="Exame"
                                />
                            </rkm-col>

                            <rkm-col cols="2">
                                <Item
                                    :get-value="() => item.solicitadoEm"
                                    label="Data da solicitação"
                                />
                            </rkm-col>

                            <rkm-col cols="2">
                                <Item
                                    :get-value="() => item.realizadoEm"
                                    label="Data da realização"
                                />
                            </rkm-col>

                            <rkm-col cols="2">
                                <Item
                                    :get-value="() => item.resultadoEm"
                                    label="Data do resultado"
                                />
                            </rkm-col>
                        </rkm-row>

                        <rkm-row v-if="getExamesPercentual().includes(item.exame.codigo)">
                            <rkm-col cols="12">
                                <Item
                                    :get-value="() => item.percentual"
                                    label="%"
                                />
                            </rkm-col>
                        </rkm-row>

                        <rkm-row v-if="getExamesPuericultura().includes(item.exame.codigo)">
                            <rkm-col cols="12">
                                <Item
                                    :get-value="() => item.resultadoTipo.nome"
                                    label="Tipo de resultado"
                                />
                            </rkm-col>
                        </rkm-row>
                    </template>

                    <template v-slot:collapse="{item}">
                        <rkm-row class="p-2">
                            <rkm-col>
                                <Item :get-value="() => item.resultado" />
                            </rkm-col>
                        </rkm-row>
                    </template>
                </rkm-list>
            </rkm-col>
        </rkm-row>
    </rkm-area>
</template>

<script>
// Components.
import Item from '@/components/ambulatorio/atendimento/components/historico/components/item/Index'

// Mixins.
import {ambulatorioAtendimentoExame, formats} from '@/mixins'

export default {
    components: {Item},
    mixins: [ambulatorioAtendimentoExame, formats],
    props: {
        item: {type: Object, required: true},
    },
}
</script>